import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../../icon.interface';
const BillingGeneralError = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="207"
        height="200"
        viewBox="0 0 207 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M157.003 39.4281C170.866 58.6849 178.362 77.8833 178.94 96.0805C179.589 114.28 173.337 131.535 165.083 149.32C156.825 167.047 146.505 185.303 132.647 187.717C118.789 190.072 101.391 176.645 82.4036 169.049C63.3478 161.51 42.7155 159.861 29.8508 148.497C17.0024 137.072 11.9896 115.929 14.585 95.3156C17.239 74.7043 27.6184 54.6123 43.54 35.7764C59.5225 16.8728 81.1644 -0.795731 102.04 0.027693C122.975 0.853456 143.202 20.1688 157.003 39.4281Z"
          fill="#F9F9F9"
        />
        <path
          d="M33.8337 22.9332L33.8337 115.026L170.268 115.026L170.268 22.9332L33.8337 22.9332Z"
          fill="#B2B2B2"
        />
        <path
          d="M169.598 116.391H33.1639L23.6016 135.491H179.136L169.598 116.391Z"
          fill="#B2B2B2"
        />
        <rect
          x="23.6113"
          y="135.491"
          width="155.535"
          height="4.09302"
          fill="#E6E6E6"
        />
        <path
          d="M39.2915 28.3907L39.2915 109.569L164.811 109.569L164.811 28.3907L39.2915 28.3907Z"
          fill="#E8F0FF"
        />
        <path
          d="M102.067 90.4682C114.123 90.4682 123.896 80.6948 123.896 68.6388C123.896 56.5827 114.123 46.8093 102.067 46.8093C90.0107 46.8093 80.2373 56.5827 80.2373 68.6388C80.2373 80.6948 90.0107 90.4682 102.067 90.4682Z"
          fill="#E90200"
        />
        <path
          d="M110.634 59.0884L92.5168 77.507M93.5007 59.0884L111.618 77.507"
          stroke="#F9F9F9"
          strokeWidth="5"
          strokeMiterlimit="10"
        />
        <path
          d="M134.608 115.555C130.421 115.219 121.352 118.983 122.373 125.66C123.072 130.254 131.616 137.181 135.24 140.173C138.697 146.171 156.792 172.412 170.894 192.388L201.926 178.661C183.861 159.255 162.743 140.932 153.962 133.641C150.325 127.397 142.961 116.222 134.608 115.555Z"
          fill="#FFB688"
        />
        <path
          d="M70.8066 113.8C74.9279 112.991 84.3653 115.702 84.1082 122.452C83.9347 127.096 76.2314 134.947 72.9706 138.331C70.2161 144.682 55.2134 172.806 43.4678 194.253L11.0797 184.134C26.8268 162.804 45.7305 142.205 53.6285 133.964C56.5337 127.349 62.5826 115.41 70.8066 113.8Z"
          fill="#FFB688"
        />
      </svg>
    );
  }
);
export default BillingGeneralError;
